// @ts-nocheck legacy file transformed to TS
// For dealing with offline storage
import localforage from 'localforage'

localforage.config({
  name: 'rpp',
})

export default localforage
